/* eslint-disable sort-keys */
export const BADGE_SIZE = {
    xxs: 16,
    xs: 24,
    sm: 32,
    md: 40,
    lg: 48,
    xl: 56,
    xxl: 64,
};
export const ICON_SIZE = {
    xxs: 'xxs',
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 28,
    xl: 'lg',
    xxl: 'xl',
};
/* eslint-enable sort-keys */
